<!--  -->
<template>
<div class='container'>
    <div class="applyDown" @click="down" v-show="classList.length !=0">
        <span class="text">报名资料下载</span>
        <i class="iconfont icon-youjiantou"></i>
    </div>
    <div class="item" v-for="(item,i) in classList" :key="i" v-show="classList.length !=0">
        <div class="title">{{item.plan_name}}{{item.course_name}} </div>
        <div class="desc">课程介绍：{{ item.desc }}</div>
        <div class="item_footer">
            <div class="left">
                <span class="time">{{item.start_time}} · {{item.week}}</span>
                <span class="applyPeople"> &nbsp;&nbsp;&nbsp;报名人数: {{item.sign_people}}/{{item.limit_people}}</span>
            </div>
            <div class="right">
                <button class="apply" @click="apply(item.id,item.course_id,item.is_use_config)">报名</button>
            </div>
        </div>

    </div>
    <div class="empty" v-show="classList.length == 0">
        <img src="../../assets/image/empty.png" alt="">
        <div class="hint">没有开班课程</div>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment'//解析时间戳
export default {
//import引入的组件需要注入到对象中才能使用
components: {
},
data() {
//这里存放数据
return {
    classList:[],//班期列表
    page:1,
    per_page:10,
    course_name:""

};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    // 获取班期数据列表
    planList(id){
        this.$toast.loading({ message: "加载中" });
        this.$http.getPlanNewList({
            page:this.page,
            per_page:this.per_page,
            pid:id
        }).then(res=>{
            this.$toast.clear();
            let list = res.data.data
            for (let index = 0; index < list.length; index++) {
                if(list[index].course_begin_time){
                    list[index].start_time = moment(list[index].course_begin_time * 1000).format('YYYY-MM-DD')
                    let week = moment(list[index].course_begin_time * 1000).format('dddd');
                    if(week == 'Sunday'){
                        list[index].week = '周日'
                    }else if(week == 'Saturday'){
                        list[index].week = '周六'
                    }
                    else if(week == 'Friday'){
                        list[index].week = '周五'
                    }
                    else if(week == 'Thursday'){
                        list[index].week = '周四'
                    }
                    else if(week == 'Wednesday'){
                        list[index].week = '周三'
                    }
                    else if(week == 'Tuesday'){
                        list[index].week = '周二'
                    }
                    else if(week == 'Monday'){
                        list[index].week = '周一'
                    }
                }
                if(list[index].course_end_time){
                    list[index].end_time = moment(list[index].course_end_time * 1000).format('YYYY-MM-DD')
                }
            }
            this.classList = list
        })
    },
    // 报名
    apply(id,course_id,useConfig){
        if(useConfig == 0){
            this.$router.push({path:"/uploadingApplyData",query:{id:id,course_id:course_id}})
        }else{
            this.$router.push({path:"/applyForm",query:{id:id,course_id:course_id}})
        }
    },
    down(){
        let course_id = this.$route.query.id
        this.$router.push({path:'/downApplyData',query:{id:course_id,course_name:this.course_name}})
    }

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    let id = this.$route.query.id
    this.course_name = this.$route.query.course_name
    this.planList(id)
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    overflow-y: auto;
    position: relative;
    .applyDown{
        width: 100%;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        padding: 11px 16px;
        box-sizing: border-box;
        margin-top: 10px;
        .text{
            font-size: 16px;
            color: #333333;
        }
        .iconfont{
            font-size: 16px;
        }
    }
    .item{
        width: 100%;
        background-color: #fff;
        margin-top: 10px;
        padding: 0 16px;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        .title{
            font-size: 16px;
            color: #333333;
            margin-top: 10px;
        }
        .desc{
            font-size: 14px;
            color: #999;
            margin-top: 10px;
        }
        .item_footer{
            font-size: 14px;
            color: #666;
            margin-top: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .apply{
            font-size: 15px;
            color: #fff;
            background-color: #2F85ED;
            width: 70px;
            height: 30px;
            border-radius: 27px;
            border: none;
        }
    }
}
</style>
